import React from 'react'
import { Divider, Row } from 'antd'
import { CustomCol } from 'src/components'
import { UserSaleOffer } from 'src/core/models'
import styles from './SaleOfferPreviewContent.module.scss'
import SaleOfferDetails from './SaleOfferDetails/SaleOfferDetails'
import SaleOfferDetailsButtons from './SaleOfferDetailsButtons/SaleOfferDetailsButtons'

const SaleOfferPreviewContent: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {
  const isOpen = offer.status === 'open'

  return (
    <div className={styles.content}>
      <Row>
        <CustomCol lg={isOpen ? 12 : 24}>
          <SaleOfferDetails offer={offer} />
        </CustomCol>
        {isOpen && <CustomCol>
          <SaleOfferDetailsButtons offer={offer} />
        </CustomCol>}
      </Row>
      <Divider />
    </div>
  )
}

export default SaleOfferPreviewContent
